import angular from 'angular';
import tableGridCheckboxCellComponent from './tableGridCheckboxCell.component';

let tableGridCheckboxCellModule = angular.module('tableGridCheckboxCell', []).directive('tableGridCheckboxCell', tableGridCheckboxCellComponent);

export default tableGridCheckboxCellModule;



// WEBPACK FOOTER //
// ./app/components/tableGridCheckboxCell/tableGridCheckboxCell.js